'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.menuBarWidget = function (navigatorModel) {
	return mmWidgets.each(this, function () {
		const container = this;
		container.find('topmenu').attr('tabindex', 1)
		.on('blur', function (e) {
			mmWidgets(e.currentTarget).find('.expanded').removeClass('expanded');
		})
		.on('mouseover', function (e) {
			const target = mmWidgets(e.currentTarget);
			if (target.parent().children(':focus').length > 0) {
				target.focus();
			}
		});
		container.find('menusection > menuitem').on('click', function (e) {
			const item = mmWidgets(e.currentTarget);
			container.find('.expanded').domElements.filter(t => t !== e.currentTarget).forEach(t => t.classList.remove('expanded'));
			if (item.next().is('submenu')) {
				item.toggleClass('expanded');
			} else {
				if (item.attr('href')) {
					navigatorModel.open(item.attr('href'));
				} else if (item.attr('data-mm-goto')) {
					navigatorModel.redirect(item.attr('data-mm-goto'));
				}

				item.parents('topmenu').blur();
			}
		});
		container.find('topmenu > submenu > menusection > menuitem')
		.on('mouseenter', function (e) {
			const item = mmWidgets(e.currentTarget);
			container.find('.expanded').domElements.filter(t => t !== e.currentTarget).forEach(t => t.classList.remove('expanded'));
			if (item.next().is('submenu')) {
				item.addClass('expanded');
			}
		});
		container.find('menusection > menuitem').domElements.forEach(function (el) {
			const element = mmWidgets(el);
			if (element.next().is('submenu')) {
				element.addClass('has-submenu');
			}
		});
		container.on('mouseleave', function () {
			container.find(':focus').blur();
		});
	});
};
